/**
 * CloudUsageReportsLink — CCA's "Cloud Usage Reports" link in Portfolio
 * details (legacy ManageAccount.vue:50-61, label verbatim).
 *
 * It opens the Cloud Usage Reports page (features/cloudusagereports, legacy
 * "Add Cloud Usage Reports"). Until that page existed the link was shown but
 * did nothing (user decision, 2026-10-15); the page is built now, at the
 * user's request, so the link leads there.
 *
 * Still a <button>, not a router link: going there is the PAGE's call
 * (`onClick`) — Manage Portfolio first asks about unsaved work and closes the
 * open portfolio, as legacy's cloudUsageReportsRedirect did, which a plain
 * link would skip. Styled as a link, as legacy draws it. Its code is fetched
 * ahead on hover / focus (the page is lazy-loaded), as PrefetchLink does.
 *
 * WHEN it shows is the page's call (ccaFormRules showsCloudUsageReports + the
 * manage_portfolio.cloud-accounts switch); this only draws it.
 */
import { CloudUsageReportsPage } from '@router/lazyPages';

import styles from './CloudUsageReportsLink.module.css';

export const CLOUD_USAGE_REPORTS_LABEL = 'Cloud Usage Reports';

/** Warm the page's chunk; a failed download is retried on the real visit. */
const preload = () => {
  CloudUsageReportsPage.preload().catch(() => {});
};

export function CloudUsageReportsLink({ onClick, disabled = false }) {
  return (
    <button
      type="button"
      id="manageportfolio-cusagereport-link"
      className={styles.link}
      onClick={onClick}
      onMouseEnter={preload}
      onFocus={preload}
      disabled={disabled}
    >
      {CLOUD_USAGE_REPORTS_LABEL}
    </button>
  );
}

export default CloudUsageReportsLink;
